import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/eyeOff.svg';

export const IconEyeOff = createIconComponent(Icon);
